import '../styles/landing.css'
import {initDebugConsole, isUrlDebugEnabled} from './shared/debug-console.js'

initDebugConsole()

/** Preserve `?debug` when opening AR pages from the landing screen. */
function withDebugParamIfNeeded(href) {
  if (!href || !isUrlDebugEnabled()) return href
  try {
    const u = new URL(href, window.location.href)
    u.searchParams.set('debug', '')
    return u.href
  } catch {
    return href
  }
}

const productLinks = document.querySelectorAll('.landing__button[href]')
const loadingText = document.querySelector('[data-loading-text]')
let isNavigating = false

function resetLandingNavigationUI() {
  isNavigating = false
  document.body.classList.remove('landing--navigating')
  if (loadingText) {
    loadingText.textContent = 'Loading...'
  }
}

// BFCache restore keeps the DOM as it was when we left (overlay + "Loading …").
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    resetLandingNavigationUI()
  }
})

productLinks.forEach((link) => {
  link.addEventListener('click', (event) => {
    if (isNavigating) {
      event.preventDefault()
      return
    }

    const href = link.getAttribute('href')
    const productName = (link.getAttribute('data-product-name') || '').trim()
    if (!href) return

    event.preventDefault()
    isNavigating = true

    if (loadingText) {
      loadingText.textContent = ''
    }
    document.body.classList.add('landing--navigating')
    // Let the overlay paint before changing page.
    window.requestAnimationFrame(() => {
      window.location.assign(withDebugParamIfNeeded(href))
    })
  })
})

window.requestAnimationFrame(() => {
  document.documentElement.classList.remove('is-preloading')
})
